<template>
  <div class="promo-tab-bar">
    <div>
      <template v-for="(item, index) in thirdPartyOptions">
        <div
          v-if="hasValidActions(item)"
          :key="index"
          :class="setSelectedClasses(item.provider)"
          @click="setSelectionName(item.provider)"
        >
          <img
            v-if="providers[item.provider] && providers[item.provider].type === 'img'"
            :src="providers[item.provider].src"
            :width="providers[item.provider].width"
          />
          <p v-else>{{ item.text }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "RfRetentionConnectorTabs",
  props: ["thirdPartyOptions", "modelValue"],
  data() {
    return {
      providers: {
        zendesk: {
          type: "img",
          src: new URL("@/assets/images/logos/zendesk.png", import.meta.url).href,
          width: "70",
        },
        custom_provider: {
          type: "img",
          src: new URL("@/assets/images/logos/custom.png", import.meta.url).href,
          width: "58",
        },

        sendgrid: {
          type: "img",
          src: new URL("@/assets/images/logos/sendgrid.png", import.meta.url).href,
          width: "85",
        },
        stripe: {
          type: "img",
          src: new URL("@/assets/images/logos/stripe.png", import.meta.url).href,
          width: "50",
        },
        salesforce: {
          type: "img",
          src: new URL("@/assets/images/logos/salesforce.png", import.meta.url).href,
          width: "85",
        },
        braze: {
          type: "img",
          src: new URL("@/assets/images/logos/logo-braze.svg", import.meta.url).href,
          width: "50",
        },
        vindicia: {
          type: "img",
          src: new URL("@/assets/images/logos/vindicia.png", import.meta.url).href,
          width: "75",
        },
        braintree: {
          type: "img",
          src: new URL("@/assets/images/logos/braintree.gif", import.meta.url).href,
          width: "88",
        },
        shopify: {
          type: "img",
          src: new URL("@/assets/images/logos/shopify.png", import.meta.url).href,
          width: "88",
        },
        zuora: {
          type: "img",
          src: new URL("@/assets/images/logos/zuora-sm.png", import.meta.url).href,
          width: "60",
        },
        segment: {
          type: "img",
          src: new URL("@/assets/images/logos/segment_io.png", import.meta.url).href,
          width: "88",
        },
        redfast: {
          type: "img",
          src: new URL("@/assets/images/engage.svg", import.meta.url).href,
          width: "80",
        },
        chargify: {
          type: "img",
          src: new URL("@/assets/images/logos/chargify.png", import.meta.url).href,
          width: "80",
        },
        freshdesk: {
          type: "img",
          src: new URL("@/assets/images/logos/freshdesk.png", import.meta.url).href,
          width: "80",
        },
        recurly: {
          type: "img",
          src: new URL("@/assets/images/logos/recurly.png", import.meta.url).href,
          width: "80",
        },
        active_campaign: {
          type: "img",
          src: new URL("@/assets/images/logos/activecampaign_logo.png", import.meta.url).href,
          width: "120",
        },
        iterable: {
          type: "img",
          src: new URL("@/assets/images/logos/iterable_logo.png", import.meta.url).href,
          width: "80",
        },
        cleeng: {
          type: "img",
          src: new URL("@/assets/images/logos/cleeng.svg", import.meta.url).href,
          width: "120",
        },
        recurly_commerce: {
          type: "img",
          src: new URL("@/assets/images/logos/recurly_commerce.png", import.meta.url).href,
          width: "120",
        },
        chargebee: {
          type: "img",
          src: new URL("@/assets/images/logos/chargebee.svg", import.meta.url).href,
          width: "100",
        },
      },
    };
  },
  methods: {
    hasValidActions(item) {
      return item?.value.actions.filter(action => action.operation).length;
    },
    setSelectedClasses(name) {
      return {
        "promo-tab": true,
        "promo-tab--active": this.modelValue === name,
      };
    },
    setSelectionName(name) {
      if (name !== this.modelValue) {
        this.$emit("update:modelValue", name);
      }
    },
  },
};
</script>
